import VueRouter from "vue-router";
import Vue from "vue";
import ArticleJs from "./article-js.vue";
import Landing from "./landing.vue";


Vue.use(VueRouter);

export default new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/article/:article',
			props: true,
			component: ArticleJs
		},
		{
			path: '/news',
			component: Landing
		}
	]
});


// WEBPACK FOOTER //
// ./src/article/router.js